import { CostCenterCriteriaValueModel } from './cost-center-criteria-values.model';

export class CostCenterCriteriaModel {
  public id: number;
  public code: string;
  public name: string;
  public value: string;
  public idCostCenterCriteriaValue: number;
  public criteriaValues: CostCenterCriteriaValueModel[];
  public codeCostCenterCriteriaValue: string;

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
